export default __webpack_public_path__ + "static/media/logo-ucBerkeley.a014b85a.jpg";